import MARKET_WISE_LOCALE from 'consts/locale';
import Local from 'modules/Local';

import { PatternOption } from 'components/common/DaypartTargeting/DaypartTargeting.types';
import { FrontEndType } from 'components/common/types/Deal.types';
import {
  DirectSalesLockStatusOption,
  DirectSalesPricingMode,
  DirectSalesStatusOption,
} from 'components/common/types/DirectSalesCampaign.types';
import { DEFAULT_CRITERIA } from 'consts/targetCriteria';

const timezone = MARKET_WISE_LOCALE[Local.getEnvironmentId() as keyof typeof MARKET_WISE_LOCALE]?.timezone || '';

export const initialDealCurrentLineData = {
  productFormats: [],
  cities: [],
  countries: [],
  counties: [],
  streets: [],
  postCodes: [],
  tags: [],
  routeFrameCodes: [],
  mapRouteFrameCodes: [],
  listFiles: [],
  uploadedFrameLists: [],
  venueTaxonomies: [],
  visualUnitCodes: [],
  visualUnitFiles: [],
  sot: undefined,
  patternRepeatType: PatternOption.NO_REPEAT,
  patternLength: 1,
  proximity: { openStreetMapPoi: [], plannerPoi: [] },
  segment: { selectedSegmentDataProvider: '', selectedSegments: {} },
  indexOptimisation: [],
  selectedDays: {},
  multiTargetingFile: null,
};

export const defaultLine = {
  ...initialDealCurrentLineData,
  budget: undefined,
  billingRule: null,
  ceilingSot: undefined,
  cpm: '',
  createdDate: new Date(),
  creativeType: undefined,
  dischargedFrameIds: [],
  earliestFrameStartDate: new Date(),
  earliestFrameTimezone: timezone,
  endDate: null,
  environments: [],
  floorSot: undefined,
  id: '',
  impressions: undefined,
  impressionMetrics: undefined,
  isCurrentLineWithProposalAllocation: false,
  isFetchingAvailability: false,
  hasAvailabilityResult: false,
  isSaving: false,
  deliveredImpressions: 0,
  latestFrameEndDate: new Date(),
  latestFrameTimezone: timezone,
  lineId: '',
  frontEndType: FrontEndType.STANDARD,
  listFiles: [],
  uploadedFrameLists: [],
  frameCpmFiles: [],
  maxCPM: undefined,
  minCPM: undefined,
  mediaOwnerMeta: [],
  name: '',
  startDate: null,
  terminated: false,
  sweep: '',
  frames: undefined,
  adjustedSot: 0,
  availability: {
    allocatedFrames: 0,
    allocatedImpressions: 0,
    assets: [],
    availableImpressions: 0,
    availableFrames: 0,
    assetCpmDistribution: {
      max: 0,
      min: 0,
      weightedMean: 0,
    },
    totalCost: 0,
    unavailableAssets: [],
    missingAssets: [],
  },
  preservedAvailability: {
    allocatedImpressions: 0,
    totalCost: 0,
    totalSot: 0,
    totalSpans: 0,
  },
  preservedAllocation: {
    allocatedFrames: 0,
    allocatedImpressions: 0,
    availableFrames: 0,
    availableImpressions: 0,
    budget: 0,
    deliveredImpressions: 0,
    frames: 0,
    impressions: 0,
    totalCost: 0,
  },
  distributionOfAvailabilityFilter: {
    distributionBy: 'frames' as const,
    groupBy: 'town' as const,
    selectedItems: [],
    locked: false,
  },
};

export const defaultDirectSales = {
  state: {
    status: DirectSalesStatusOption.DRAFT_UPDATING,
  },
  lockState: {
    status: DirectSalesLockStatusOption.UNLOCKED,
  },
  transientState: undefined,
  mediaType: undefined,
  budgetCriteria: DEFAULT_CRITERIA,
  framesCriteria: DEFAULT_CRITERIA,
  impressionsCriteria: DEFAULT_CRITERIA,
  networkCriteria: [],
  pricingMode: DirectSalesPricingMode.CPM,
  dealLineFormats: [],
  locations: [],
  poi: [],
  poiPoints: [],
  allocation: {},
  objectives: [],
  transientLineStates: {},
  productTemplate: {
    id: '',
    name: '',
  },
  floatingRange: null,
  sotObjectiveId: undefined,
  enabledForSharing: undefined,
  campaignPlanShareUrl: undefined,
  campaignPlanShareExpiresAt: undefined,
  isGenerateCampaignPlanEnabled: false,
  hasUnsavedCampaignPlanConfigChanges: false,
  isCampaignPlanLinkDiscardModalOpen: false,
  weekStartDate: undefined,
  periodType: undefined,
  updatedGridNegotiationTypes: [],
};

export const defaultDirectSalesLine = {
  id: '',
  productTemplate: {
    id: '',
    name: '',
  },
  floatingRange: null,
  budgetCriteria: {
    priority: {
      code: '',
      name: '',
    },
    greenTolerance: 0,
    orangeTolerance: 0,
  },
  framesCriteria: {
    priority: {
      code: '',
      name: '',
    },
    greenTolerance: 0,
    orangeTolerance: 0,
  },
  impressionsCriteria: {
    priority: {
      code: '',
      name: '',
    },
    greenTolerance: 0,
    orangeTolerance: 0,
  },
  networkCriteria: [],
  pricingMode: DirectSalesPricingMode.CPM,
};
